import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, LogOut, Settings, FolderOpen } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const navLinkClass = (path: string) =>
    `flex items-center gap-1.5 text-sm font-medium transition-colors ${
      location.pathname === path
        ? "text-primary-foreground"
        : "text-primary-foreground/60 hover:text-primary-foreground"
    }`;

  return (
    <header className="bg-primary text-primary-foreground">
      <div className="container-lg px-6 flex items-center justify-between h-14">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2 font-bold text-lg tracking-tight">
            <img src="/logo-icon.svg" alt="Logo" className="w-8 h-8" />
            <span>Lumanity</span>
          </Link>
          <div className="h-6 w-px bg-primary-foreground/30" />
          <Link to="/" className={navLinkClass("/")}>
            <Home className="w-4 h-4" />
            Home
          </Link>
          <Link to="/projects" className={navLinkClass("/projects")}>
            <FolderOpen className="w-4 h-4" />
            Projects
          </Link>
          {user?.role === "Admin" && (
            <Link to="/admin" className={navLinkClass("/admin")}>
              <Settings className="w-4 h-4" />
              Admin
            </Link>
          )}
        </div>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-brand-teal flex items-center justify-center text-xs font-bold">
            {user ? `${user.firstName[0]}${user.lastName[0]}` : "??"}
          </div>
          <div className="text-sm">
            <div className="font-medium leading-tight">
              {user ? `${user.firstName} ${user.lastName}` : "Unknown"}
            </div>
            <div className="text-primary-foreground/60 text-xs">
              {user?.role || "User"}
            </div>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="ml-2 p-1.5 rounded hover:bg-primary-foreground/10 transition-colors"
            title="Sign out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
